export default __webpack_public_path__ + "static/SourceCodePro.bold-759cda5774fb8a57d93b58e1a458d1fa.ttf";